import { useActionButtons } from 'features/actions/actionHooks'
import { RelatedRecordWidgetType } from 'features/views/LayoutEditor/widgets/RelatedRecordWidget/types'

import useDeepEqualsMemoValue from 'v2/ui/utils/useDeepEqualsMemoValue'

import { useResponsiveValue } from 'ui/styling/helpers/useResponsiveValue'

const MAX_VISIBLE_ACTIONS = 2

type UseRelatedRecordWidgetActionsStateProps = {
    widget: RelatedRecordWidgetType
    object?: ObjectDto
    record?: RecordDto
}

export function useRelatedRecordWidgetActionsState({
    widget,
    object,
    record,
}: UseRelatedRecordWidgetActionsStateProps) {
    const actionButtons = widget.attrs.actionButtons ?? []
    const actions = useActionButtons(actionButtons, record!, object!).map((a) => a.action)

    const visibleActions = actions.slice(0, MAX_VISIBLE_ACTIONS)
    const menuActions = actions.slice(MAX_VISIBLE_ACTIONS)

    const menuButtonOffset = !!menuActions.length ? 1 : 0

    const gridTemplateColumns = useResponsiveValue({
        mobile: `repeat(${visibleActions.length}, 1fr) ${menuButtonOffset ? 'minmax(0, max-content)' : ''}`,
        tablet: `repeat(${visibleActions.length + menuButtonOffset}, minmax(10px, max-content))`,
    })
    const minWidth = `${(visibleActions.length + menuButtonOffset) * 32}px`

    const shouldShow = visibleActions.length > 0 || menuActions.length > 0

    return useDeepEqualsMemoValue({
        visibleActions,
        menuActions,
        gridTemplateColumns,
        minWidth,
        shouldShow,
    })
}
